import PropTypes from "prop-types";
import { formatDate } from "@/utils/helpers";
import { TruncatedTextCell } from "@/components/facility/planboard/AddWorkOrderInspectionList";
import { formatNumber, formatDecimalValues } from "@/utils/helpers";

function DateCell({ value }) {
  return (
    <div className="date-cell">
      {value ? formatDate(new Date(value)) : ""}
    </div>
  );
}

DateCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export const getTransferTableColumns = () => [
  {
    Header: "Trans #",
    accessor: "journalEntryId",
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Date",
    accessor: "postingDate",
    Cell: DateCell,
  },
  {
    Header: "Company",
    accessor: "companyName",
  },
  {
    Header: "Building",
    accessor: "buildingName",
  },
  {
    Header: "Component",
    accessor: "componentName",
  },
  {
    Header: "Unit",
    accessor: "unitName",
  },
  {
    Header: "GL Account",
    accessor: "accountName",
  },
  {
    Header: "GL Account Code",
    accessor: "accountCode",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Debit (AED)",
    accessor: "debitAmount",
  },
  {
    Header: "Credit (AED)",
    accessor: "creditAmount",
  }
];

function JournalVoucherCell({ value }) {
  if (!value) return <div />;

  if (Array.isArray(value)) {
    return  <div ><TruncatedTextCell value={value.map((v) => v.name).join(", ")} /> </div>;
  }

  return(
    <div className="link-cell">
        <TruncatedTextCell value={value.type} />
    </div>)
}

const NumberCell= ({ value }) => (
  <span>{formatDecimalValues(value)}</span>
);

const DebitCreditCell= ({ value }) => {
  return(
  <span>{value ? "Debit" : "Credit"}</span>
)};

const CurrencyCodeCell= ({ value, row }) => {
  return(
  <span>{value ? row.original.debitCurrencyCode : row.original.creditCurrencyCode}</span>
)};

export const getTransferListTableColumns = () => [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Amount",
    accessor: "balance",
  },
  {
    Header: "Currency Code",
    accessor: "debitCurrencyCode",
    Cell: CurrencyCodeCell
  },
  {
    Header: "Debit/Credit",
    accessor: "isDebit",
    Cell: DebitCreditCell
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Exchange Rate",
    accessor: "exchangeRate",
    Cell: NumberCell
  },
  {
    Header: "Cost Centers",
    accessor: "costCenters",
    Cell: JournalVoucherCell
  },
  {
    Header: "Transfer State",
    accessor: "transferState",
  },
];

export const getTransferTableData = (data, companyName) => {
  if (!data) {
    return [];
  }

  return data.map((transfer) => ({
    ...transfer,
    companyName
  }));
};
